"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidSnSCountry = exports.ALLOWED_SNS_AMAZON_VENDOR_MARKETPLACES = exports.ALLOWED_SNS_AMAZON_MARKETPLACES = void 0;
exports.ALLOWED_SNS_AMAZON_MARKETPLACES = [
    "USA",
    "CAN",
    "ESP",
    "GBR",
    "FRA",
    "ITA",
    "IND",
    "DEU",
    "JPN",
    "AUS",
];
exports.ALLOWED_SNS_AMAZON_VENDOR_MARKETPLACES = [
    ...exports.ALLOWED_SNS_AMAZON_MARKETPLACES,
    "BRA",
    "MEX",
    "UAE",
    "NLD",
];
const isValidSnSCountry = (marketplaceType, countryCode) => {
    if (marketplaceType === "amazon" &&
        exports.ALLOWED_SNS_AMAZON_MARKETPLACES.includes(countryCode)) {
        return true;
    }
    else if (marketplaceType === "amazon_vendor" &&
        exports.ALLOWED_SNS_AMAZON_VENDOR_MARKETPLACES.includes(countryCode)) {
        return true;
    }
    return false;
};
exports.isValidSnSCountry = isValidSnSCountry;
//# sourceMappingURL=countryUtils.js.map